import * as React from 'react';

import * as styles from './styles.css';

export interface ILinkProps {
  onClick(): void;
  testId?: string;
}

export const AlertInlineAction: React.FC<React.PropsWithChildren<ILinkProps>> = ({ onClick, children, testId }) => {
  return (
    <span className={styles['root']} data-testid={testId} onClick={onClick} role="button">
      {children}
    </span>
  );
};

AlertInlineAction.displayName = 'AlertInlineAction';
